<template>
    <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
            <!--
                :large="large"
            :x-large="xLarge"
            :small="small"
            
            :color="color"
                -->
            <v-btn v-on="{ ...tooltip, ...activator}" 
            v-bind="$attrs"
            :to="to"
            :icon="!fab && !noIconAttr"
            :fab="fab"
            :light="light"
            :dark="dark"
            :class="buttonClass"
            @click="$emit('click')" :exact="!!to"><v-icon :light="light" :dark="dark">{{ icon }}</v-icon></v-btn>
        </template>
        <span>{{tooltip}}</span>
    </v-tooltip>
</template>
<script>
export default {
    name: 'ActionButton',
    data() {
      return {
      };
    },
    props: {
        'tooltip': {type: String, default: 'Edit' },
        'icon': {type: String, default: '$edit' },
        'no-icon-attr': {type: Boolean },
        'to': { type: [String, Object] },
        'fab': {type: Boolean },
        /*
        'color': {type: String },
        'href': {type: String },
        
        'small': { type: Boolean },
        'large': { type: Boolean },
        'xLarge': { type: Boolean },
        
        */
        'button-class': { type: [String, Array, Object]},
        'dark': {type: Boolean },
        'light': {type: Boolean },
        'activator': {type: [Object, Function ]},
    },
    computed: {
    }
}
</script>